import { useState, useEffect } from 'react';

const useNotifications = () => {
  const [notificationPermission, setNotificationPermission] =
    useState('default');
  const [lastMessageSender, setLastMessageSender] = useState(null);
  const [isPageVisible, setIsPageVisible] = useState(true);

  useEffect(() => {
    // Request notification permission
    if ('Notification' in window) {
      Notification.requestPermission().then((permission) => {
        setNotificationPermission(permission);
      });
    }

    // Handle page visibility changes
    const handleVisibilityChange = () => {
      setIsPageVisible(document.visibilityState === 'visible');
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  const showNotification = (message, sender) => {
    // if (
    //   notificationPermission === 'granted' &&
    //   !isPageVisible &&
    //   sender !== lastMessageSender
    // ) {
      new Notification('Nuovo Messaggio', {
        body: message,
        icon: '/images/notification.png',
      });
      setLastMessageSender(sender);
    // }
  };

  return {
    showNotification,
    notificationPermission,
    isPageVisible,
  };
};

export default useNotifications;
